import styled, { css } from 'styled-components';

import { TextButton } from '@xing-com/button';
import {
  cornerRadiusXL,
  scale010,
  scale150,
  scale210,
  spaceS,
  xdlColorText,
  xdlColorTextTertiary,
  xdlColorFocusRing,
} from '@xing-com/tokens';

import type {
  FeedbackButtonExpression,
  FeedbackButtonVariant,
} from './feedback-button.types';

type FeedbackButtonTProps = {
  $expression?: FeedbackButtonExpression;
  $isDisabled?: boolean;
  $variant?: FeedbackButtonVariant;
};

type LabelTProps = {
  $isActive?: boolean;
  $isHovered?: boolean;
};

// *** Components ***
export const FeedbackButton = styled.button<FeedbackButtonTProps>`
  align-items: center;
  background: transparent;
  border-radius: ${cornerRadiusXL};
  border: none;
  color: ${xdlColorText};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font-weight: 700;
  gap: ${spaceS};

  &:focus {
    outline: ${scale010} solid ${xdlColorFocusRing};
    outline-offset: ${spaceS};
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &:focus-visible {
    outline: ${scale010} solid ${xdlColorFocusRing};
    outline-offset: ${spaceS};
  }

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      pointer-events: none;
    `};
`;

export const IconWrapper = styled.div`
  height: ${scale150};
  width: ${scale150};
`;

export const Label = styled(TextButton)<LabelTProps>`
  max-width: ${scale210};

  /* Force hover styles when parent is hovered */
  ${({ $isHovered, $isActive }) =>
    $isHovered &&
    !$isActive &&
    css`
      &:not(:disabled) {
        text-decoration-line: underline;
        text-decoration-skip-ink: none;
        text-decoration-style: solid;
        text-decoration-thickness: 13%;
        text-underline-offset: 20%;
        text-underline-position: from-font;
      }
    `};

  ${({ $isActive }) =>
    $isActive &&
    css`
      &:not(:disabled) {
        color: ${xdlColorTextTertiary};
        text-decoration-line: none;
      }
    `};
`;
